export default __webpack_public_path__ + "2f8ea52972738c867991974a61140760.svg";